import riot from 'riot'
import router from '#util/routes'
import logger from '#util/logger'

// require babel polyfill for browser compatibility
// import 'babel-polyfill';

// Require styles
import '../scss/entry.scss';

// Require Mixins
import '#util/mixins'

// Require Observables
import '#util/observables'

// Require API
import '#util/api'


// Import components
import './components/anchored-heading/anchored-heading.tag'
import './components/apple-pay/apple-pay.tag'
import './components/cdr-banner/cdr-banner.tag'
import './components/klarna/klarna.tag'
import './components/op-accordion/op-accordion.tag'
import './components/op-address-collapsed/op-address-collapsed.tag'
import './components/op-button/op-button.tag'
import './components/op-checkboxinput/op-checkboxinput.tag'
import './components/op-creditcardinput/op-creditcardinput.tag'
import './components/op-curbside-pickup/op-curbside-pickup.tag'
import './components/op-dropdownselect/op-dropdownselect.tag'
// import './components/op-electronic-item/op-electronic-item.tag'; // not used
import './components/op-emailinput/op-emailinput.tag'
import './components/op-giftcardinput/op-giftcardinput.tag'
import './components/op-giftcardpininput/op-giftcardpininput.tag'
import './components/op-modal/op-modal.tag'
import './components/op-mystore-chip/op-mystore-chip.tag'
import './components/op-notification/op-notification.tag'
import './components/op-phoneinput/op-phoneinput.tag'
// import './components/op-pickup-item/op-pickup-item.tag'; // not used
import './components/op-radioinput/op-radioinput.tag'
import './components/op-ship-item-card/op-ship-item-card.tag'
// import './components/op-ship-item/op-ship-item.tag'; // not used
import './components/op-switch/op-switch.tag'
import './components/op-textinput/op-textinput.tag'
import './components/op-tooltip/op-tooltip.tag'
import './components/op-warning/op-warning.tag'
import './components/order-item-badge/order-item-badge.tag'
import './components/order-item-restrictions/order-item-restrictions-new.tag'
import './components/order-item-restrictions/order-item-restrictions.tag'
import './components/order-item/order-item-new.tag'
import './components/order-metadata-new/order-metadata-new.tag'
// import './components/order-metadata/order-metadata.tag' // not used
import './components/raw/raw.tag'
import './components/rei-logo/rei-logo.tag'
import './components/section-header/section-header.tag'
import './components/section-navigation/section-navigation.tag'
import './compositions/address-form/address-form.tag'
import './compositions/common/country-select/country-select.tag'
import './compositions/common/employee-info/employee-info.tag'
import './compositions/common/event-widgets/resupply-widget.tag'
import './compositions/common/global-message/global-message.tag'
import './compositions/common/op-cards/op-card/op-card.tag'
import './compositions/common/op-cards/op-giftcard-card/op-giftcard-card.tag'
import './compositions/common/op-cards/op-pickup-card/op-pickup-card.tag'
import './compositions/common/op-cards/op-product-card/op-product-card.tag'
import './compositions/common/order-summary/coupons/coupons.tag'
import './compositions/common/order-summary/coupons/tap-coupon.tag'
import './compositions/common/order-summary/rcaf-widget/rcaf-widget.tag'
import './compositions/common/order-summary/gift-cards/gift-cards.tag'
import './compositions/common/order-summary/guest-checkout-registration/guest-checkout-registration.tag'
import './compositions/common/order-summary/app-download-widget/app-download-widget.tag'
import './compositions/common/order-summary/op-dividend-summary.tag'
import './compositions/common/order-summary/order-summary.tag'
import './compositions/common/order-summary/saved-gift-cards/saved-gift-cards.tag'
import './compositions/common/section-continue/section-continue.tag'
import './compositions/common/state-province-select/state-province-select.tag'
import './compositions/final-submit/final-submit-new.tag'
import './compositions/modals/backorder-preorder-modal/backorder-preorder-modal.tag'
import './compositions/modals/billing-address-errors/invalid-address-info-modal.tag'
import './compositions/modals/billing-address-errors/invalid-contact-info-modal.tag'
import './compositions/modals/co-delivery-fee-modal/co-delivery-fee-modal.tag'
import './compositions/modals/coupon-terms-conditions-modal/coupon-terms-conditions-modal.tag'
import './compositions/modals/credit-card-cvv-modal/credit-card-cvv-modal.tag'
import './compositions/modals/duty-information-modal/duty-information-modal.tag'
import './compositions/modals/e2e-service-error-modal/e2e-service-error-modal.tag'
import './compositions/modals/earning-redeeming-rewards-modal/earning-redeeming-rewards-modal.tag'
import './compositions/modals/employee-info-modal/employee-info-modal.tag'
import './compositions/modals/empty-cart-modal/empty-cart-modal.tag'
import './compositions/modals/general-error-order-modal/general-error-order-modal.tag'
import './compositions/modals/gift-card-pin-modal/gift-card-pin-modal.tag'
import './compositions/modals/gift-options-modal/gift-options-modal.tag'
import './compositions/modals/items-unavailable-modal/items-unavailable-modal.tag'
import './compositions/modals/line-item-limit-modal/line-item-limit-modal.tag'
import './compositions/modals/mabc-improvements-modal/mabc-improvements-modal.tag'
import './compositions/modals/member-coupon-requirements-modal/member-coupon-requirements-modal.tag'
import './compositions/modals/member-dividend-info-modal/member-dividend-info-modal.tag'
import './compositions/modals/member-only-modal/member-only-modal.tag'
import './compositions/modals/membership-benefits-modal/membership-benefits-modal.tag'
import './compositions/modals/mn-delivery-fee-modal/mn-delivery-fee-modal.tag'
import './compositions/modals/notify-me-modal/notify-me-modal.tag'
import './compositions/modals/refresh-limit-modal/refresh-limit-modal.tag'
import './compositions/modals/rei-member-benefits-modal/rei-member-benefits-modal.tag'
import './compositions/modals/scheduled-delivery-warning-modal/scheduled-delivery-warning-modal.tag'
import './compositions/modals/select-billing-address-modal/select-billing-address-modal.tag'
import './compositions/modals/select-shipping-address-modal/select-shipping-address-modal.tag'
import './compositions/modals/service-error-order-modal/service-error-order-modal.tag'
import './compositions/modals/tax-information-modal/tax-information-modal.tag'
import './compositions/modals/total-rewards-cover-modal/total-rewards-cover-modal.tag'
import './compositions/modals/total-rewards-modal/total-rewards-modal.tag'
import './compositions/modals/usps-validation-modal/usps-validation-modal.tag'
import './compositions/modals/what-is-paypal-modal/what-is-paypal-modal.tag'
import './compositions/modals/where-are-my-rewards-modal/where-are-my-rewards-modal.tag'
import './compositions/op-app/op-app.tag'
import './compositions/op-blurb/op-blurb.tag'
import './compositions/pages/contact-billing-page/contact-billing-page.tag'
import './compositions/pages/membership-page/attach-by-member-number/attach-by-member-number.tag'
import './compositions/pages/membership-page/lookup-by-email/lookup-by-email.tag'
import './compositions/pages/membership-page/membership-page.tag'
import './compositions/pages/membership-page/verify-member-number-by-email/verify-member-number-by-email.tag'
import './compositions/pages/order-confirmation-page/order-confirmation-page.tag'
import './compositions/pages/order-review-page-new/billing-address-review-new/billing-address-review-new.tag'
import './compositions/pages/order-review-page-new/cobrand-offer-review/cobrand-offer-review.tag'
import './compositions/pages/order-review-page-new/contact-info-review-new/contact-info-review-new.tag'
import './compositions/pages/order-review-page-new/electronic-item-review-new/electronic-item-review-new.tag'
import './compositions/pages/order-review-page-new/items-shipping-review-new/items-shipping-review-new.tag'
import './compositions/pages/order-review-page-new/legal-info-accordion/legal-info-accordion.tag'
import './compositions/pages/order-review-page-new/limited-time-offer/limited-time-offer.tag'
import './compositions/pages/order-review-page-new/membership-review/membership-review.tag'
import './compositions/pages/order-review-page-new/new-membership-review-new/new-membership-review-new.tag'
import './compositions/pages/order-review-page-new/order-review-page.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/op-cc-expiration.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/op-credit-card-form.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/op-cvv.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/op-ila.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/op-payment-methods.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/op-saved-credit-card.tag'
import './compositions/pages/order-review-page-new/payment-method-review-new/payment-method-review-new.tag'
import './compositions/pages/order-review-page-new/rewards-giftcards-coupons-review/rewards-giftcards-coupons-review.tag'
import './compositions/pages/order-review-page-new/store-pickup-review-new/store-pickup-review-new.tag'
import './compositions/pages/shipping-options-page/shipping-options-page.tag'
import './compositions/pages/store-pickup-page/store-pickup-page.tag'
import './compositions/pages/transition-page/transition-page.tag'
import './compositions/partials/op-address-selection/op-address-selection.tag'
import './compositions/partials/op-gc-shipping-options/op-gc-shipping-options.tag'
import './compositions/partials/op-gc-shipping-options/op-pgc-shipping-options/op-pgc-shipping-options.tag'
import './compositions/partials/op-gift-options/op-gift-options.tag'
import './compositions/partials/op-membership-page--add-new-membership/op-membership-page--add-new-membership.tag'
import './compositions/partials/op-membership-page--existing-membership/op-membership-page--existing-membership.tag'
import './compositions/partials/op-membership-page--new-membership/op-membership-page--new-membership.tag'
import './compositions/partials/op-payment-page--gift-card-section/op-payment-page--gift-card-section.tag'
import './compositions/partials/op-product-shipping-options/op-product-shipping-options.tag'
import './compositions/partials/op-saved-shipping-addresses/op-saved-address/op-saved-address.tag'
import './compositions/partials/op-saved-shipping-addresses/op-saved-shipping-addresses.tag'
import './compositions/partials/op-shipping-methods/op-shipping-methods.tag';


(function appIIFE() {
  // Start Application
  logger('Welcome to REI Checkout :: Application Start', 'info')()
  riot.mount('*', {
    router,
  })
}())


// export default function createRiotApp() {
//   const app = (function appIIFE() {
//     // Start Application
//     logger('Welcome to REI Checkout :: Application Start', 'info')();
//     return riot.mount('*', {
//       router,
//     });
//   }());
//   return { app };
// }